import { useQuery } from '@tanstack/react-query';
import { getClaimMediaConfig } from '@/lib/vehicle-claims/api';
import type { RequestContext } from '../requestContext';

export const claimMediaSlotsKeys = {
  all: ['claim-media-config'] as const,
};

// This taxonomy only changes via a backend migration, so it never needs to be
// refetched due to staleness within a browser session.
export const CLAIM_MEDIA_CONFIG_STALE_TIME = Infinity;

export function useClaimMediaSlots(context?: RequestContext) {
  return useQuery({
    queryKey: claimMediaSlotsKeys.all,
    queryFn: () => (context ? getClaimMediaConfig(context) : getClaimMediaConfig()),
    staleTime: CLAIM_MEDIA_CONFIG_STALE_TIME,
  });
}
